module.exports = __webpack_public_path__ + "static/media/shuttlecock-21263_1920.abc4dc4d.webp";